export const AuditAction = {
	SendSystemTask: "SEND_SYSTEM_TASK",
	SetRestaurantStatus: "SET_RESTAURANT_STATUS",
};

export const AuditResource = {
	Kitchen: "KITCHEN",
	Restaurant: "RESTAURANT",
};

export const AUDIT_LOG_PAGE_SIZE = 10;
